import { observer } from "mobx-react-lite";
import React from "react";
import {FormFieldLine} from "../../../../../components/form-field-line/form-field-line";
import {IOption, SelectDropdown,} from "../../../../../components/inputs/select-dropdown/select-dropdown";
import {GlobalEEnvironment} from "../../../../../services/api/admin-migrate-global-e-merchants-service";
import {SingleValue} from "react-select";
import supportedGlobalEEnvsStore from "../../stores/supported-global-e-envs-store";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";

interface IGlobaleEnvironmentSelectorProps {
    onChange?: (env: GlobalEEnvironment) => void;
    value?: GlobalEEnvironment;
    disbled?: boolean;
}

const GlobaleEnvironmentSelector: React.FC<IGlobaleEnvironmentSelectorProps> = observer(({ onChange, value, disbled = false }) => {
    const { isLoading, isLoaded, hasSupportedEnvironments, environmentOptions } = supportedGlobalEEnvsStore;

    const selectedOption: IOption | null =
        environmentOptions.find((o) => o.value === value)
        ?? (value ? { value, label: String(value) } : null);

    const handleChange = (option: SingleValue<IOption>) => {
        const env = option?.value as GlobalEEnvironment;
        onChange?.(env);
    };

    if (isLoaded && !hasSupportedEnvironments) {
        return (
            <FormFieldLine label="Global-e Environment">
                <FontBody1 color={FONT_COLOR.PRIMARY2}>
                    No Global-e environments are supported
                </FontBody1>
            </FormFieldLine>
        );
    }

    return (
        <FormFieldLine label="Global-e Environment">
            <SelectDropdown
                isSearchable={false}
                value={selectedOption}
                options={environmentOptions}
                onChange={handleChange}
                placeholder={isLoading ? "Loading environments..." : "Select environment"}
                required={true}
                disabled={disbled || isLoading || !isLoaded || !hasSupportedEnvironments}
            />
        </FormFieldLine>
    );
});

export default GlobaleEnvironmentSelector;
